import React from "react";
import { useGlobal } from "reactn";

import "../../styles/avm/spinner.scss";

const Spinner = () => {
  const [callsNum] = useGlobal("BUSY"); // number of concurrent calls that are in progress; spinner is shown if > 0

  return (
    !!callsNum && (
      <div className="spinner">
        <div className="spinner-ripple">
          <div></div>
          <div></div>
        </div>
      </div>
    )
  );
};

export default Spinner;
